import "./App.css";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import SignInOut from "./SignInOut/SignInOut";
import Sidebar from "./Sidebar/Sidebar";
import EditTrainer from "./Trainers/EditTrainer";
import Ricerche from "./Richerche/Ricerche";
import EditRicerche from "./Richerche/EditRicerche";
import AddRicerche from "./Richerche/AddRicerche";
import Associazioni from "./Associazioni/Associazioni";
import AddAssociazioni from "./Associazioni/AddAssociazioni";
import Trainers from "./Trainers/Trainers.jsx";
import Sedi from "./Sedi/Sedi.jsx";
import AddSedi from "./Sedi/AddSedi.jsx";
import EditSedi from "./Sedi/EditSedi.jsx";
import { ToastContainer } from "react-toastify";
import TrainerProfile from "./Trainers/TrainerProfile.jsx";
import TipologiaTitoli from "./TipologieTitoli/TipologiaTitoli.jsx";
import AddTipologiaTitolo from "./TipologieTitoli/AddTipologiaTitolo";
import EditTipologiaTitolo from "./TipologieTitoli/EditTipologiaTitolo.jsx";
import TitoloStudio from "./TitoliDiStudi/TitoliStudio.jsx";
import AddTitoliStudio from "./TitoliDiStudi/AddTitoliStudio.jsx";
import Mansioni from "./Mansioni/Mansioni.jsx";
import AddMansioni from "./Mansioni/AddMansioni.jsx";
import EditMansioni from "./Mansioni/EditMansioni.jsx";
import SediMe from "./Sedi/SediMe.jsx";
import OpenPositions from "./OpenPositions/OpenPositions.jsx";
import OperatorRicerche from "./Richerche/OperatorRicerche.jsx";
import MeCurriculum from "./Curriculum/MeCurriculum.jsx";
import Feedback from "./Feedback/Feedback.jsx";
import ModuliProtocollati from "./ModuliProtocollati/ModuliProtocollati.jsx";
import AddModuliProtocollato from "./ModuliProtocollati/AddModuliProtocollati.jsx";
import FollowUp from "./FollowUp/FollowUp.jsx";
import AddFollowUp from "./FollowUp/AddFollowUp.jsx";
import EditFollowUp from "./FollowUp/EditFollowUp.jsx";
import EditAssociazione from "./Associazioni/EditAssociazioni.jsx";
import Simulazioni from "./Simulazioni/Simulazioni.jsx";
import AddSimulazioni from "./Simulazioni/AddSimulazioni.jsx";
import EditSimulazioni from "./Simulazioni/EditSimulazioni.jsx";
import EditModuliProtocollati from "./ModuliProtocollati/EditModuliProtocollati.jsx";
import EsperienzeLavorative from "./EsperienzeLavorative/EsperienzeLavorative.jsx";
import AddEsperienzaLavorativa from "./EsperienzeLavorative/AddEsperienzaLavorativa .jsx";
import EditTitoliStudi from "./TitoliDiStudi/EditTitoliStudio.jsx";
import AddFeedback from "./Feedback/AddFeedback.jsx";
import { useEffect, useState } from "react";
import Navbar from "./Navbar/Navbar.jsx";
import Users from "./Users/Users.jsx";
import AddUser from "./Users/AddUsers.jsx";
import EditUser from "./Users/EditUsers.jsx";
import AccordoQuadro from "./AccordoQuadro/AccordoQuadro.jsx";
import Interviste from "./Interviste/Interviste.jsx";
import UserProfile from "./Users/UserProfile.jsx";
import EditEsperienzeLavorative from "./EsperienzeLavorative/EditEsperienzeLavorative.jsx";
import ActivateAccount from "./Users/ActivateAccount.jsx";
import AddAccordoQuadro from "./AccordoQuadro/AddAccordoQuadro.jsx";
import EditAccordoQuadro from "./AccordoQuadro/EditAccordoQuadro.jsx";
import AddIntervista from "./Interviste/AddIntervista.jsx";
import EditIntervista from "./Interviste/EditInterviste.jsx";
import CandidatureTrainer from "./Candidature/CandidatureTrainer.jsx";
import Candidature from "./Candidature/Candidature.jsx";
import CandidatureDetails from "./Candidature/CandidatureDetails.jsx";
import OperatoreTrainers from "./Trainers/OperatoreTrainers.jsx";
import EditFeedback from "./Feedback/EditFeedback.jsx";
import ResetPassword from "./Users/ResetPassword.jsx";

function App() {
  const location = useLocation();
  const accessToken = localStorage.getItem("accessToken");
  const [showSidebar, setShowSidebar] = useState(false);
  const userRole = localStorage.getItem("userRole");
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setShowSidebar(width > 992 && height > 650);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const tryRefreshToken = async () => {
      const accessToken = localStorage.getItem("accessToken");
      const refreshToken = localStorage.getItem("refreshToken");

      if (!accessToken && refreshToken) {
        try {
          const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}/auth/refresh-token`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${refreshToken}`,
              },
            }
          );

          if (!res.ok) throw new Error("Refresh failed");

          const data = await res.json();
          localStorage.setItem("accessToken", data.access_token);
        } catch (error) {
          console.error("Refresh failed:", error);
          localStorage.clear();
          window.location.href = "/login";
          return;
        }
      }
      setLoading(false);
    };
    tryRefreshToken();
  }, []);

  const isPublicRoute =
    location.pathname === "/login" ||
    location.pathname === "/auth/activate-account" ||
    location.pathname === "/auth/reset-password";

  if (isPublicRoute) {
    return (
      <>
        <Routes>
          <Route path="/login" element={<SignInOut />} />
          <Route path="/auth/activate-account" element={<ActivateAccount />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
        </Routes>
        <ToastContainer />
      </>
    );
  }

  if (loading) {
    return (
      <div className="overlay">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className={`layout ${!showSidebar ? "navbar-visible" : ""}`}>
      {accessToken && showSidebar && <Sidebar />}
      {accessToken && !showSidebar && <Navbar />}
      <div className="main-content">
        <Routes>
          <Route
            path="/"
            element={(() => {
              const storedRole = localStorage.getItem("userRole");
              if (!storedRole) return <Navigate to="/login" replace />;
              if (storedRole === "ADMIN")
                return <Navigate to="/docenti" replace />;
              if (storedRole === "TRAINER")
                return <Navigate to="/docente/posizioni-aperte" replace />;
              if (storedRole === "OPERATOR")
                return <Navigate to="/ricerche/me" replace />;
              return <Navigate to="/login" replace />;
            })()}
          />

          <Route path="/docenti" element={<Trainers />} />
          <Route path="/docenti/disponibile" element={<OperatoreTrainers />} />
          <Route path="/docente/disponibile/:id" element={<EditTrainer />} />
          <Route path="/docente/:id" element={<EditTrainer />} />
          <Route
            path="/ricerche/posizioni-aperte"
            element={<OpenPositions />}
          />
          <Route path="/candidature" element={<Candidature />} />
          <Route path="/candidature/:id" element={<CandidatureDetails />} />
          <Route path="/candidature/me" element={<CandidatureTrainer />} />
          <Route path="/ricerche" element={<Ricerche />} />
          <Route path="/ricerca/:id" element={<EditRicerche />} />
          <Route path="/ricerche/me" element={<OperatorRicerche />} />
          <Route path="/aggiungi-ricerca" element={<AddRicerche />} />
          <Route path="/associazioni" element={<Associazioni />} />
          <Route path="/associazione/:id" element={<EditAssociazione />} />
          <Route path="/aggiungi-associazione" element={<AddAssociazioni />} />
          <Route path="/sedi" element={<Sedi />} />
          <Route path="/sede/:id" element={<EditSedi />} />
          <Route path="/aggiungi-sede" element={<AddSedi />} />
          <Route path="/sedi/me" element={<SediMe />} />
          <Route path="/tipologia-titolo" element={<TipologiaTitoli />} />
          <Route
            path="/aggiungi-tipologia-titolo"
            element={<AddTipologiaTitolo />}
          />
          <Route
            path="/tipologia-titolo/:id"
            element={<EditTipologiaTitolo />}
          />
          <Route path="/titoli-studi" element={<TitoloStudio />} />

          <Route path="/aggiungi-titoli-studi" element={<AddTitoliStudio />} />
          <Route path="/titoli-studi/:id" element={<EditTitoliStudi />} />
          <Route path="/mansioni" element={<Mansioni />} />
          <Route path="/aggiungi-mansione" element={<AddMansioni />} />
          <Route path="/mansioni/:id" element={<EditMansioni />} />
          <Route path="/curriculum" element={<MeCurriculum />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/aggiungi-feedback" element={<AddFeedback />} />
          <Route path="/feedback/:id" element={<EditFeedback />} />
          <Route path="/moduli-protocollati" element={<ModuliProtocollati />} />
          <Route
            path="/moduli-protocollati/:id"
            element={<EditModuliProtocollati />}
          />
          <Route
            path="/aggiungi-moduli-protocollati"
            element={<AddModuliProtocollato />}
          />
          <Route path="/follow-up" element={<FollowUp />} />
          <Route path="/aggiungi-follow-up" element={<AddFollowUp />} />
          <Route path="/follow-up/:id" element={<EditFollowUp />} />
          <Route path="/simulazioni" element={<Simulazioni />} />
          <Route path="/simulazione/:id" element={<EditSimulazioni />} />
          <Route path="/aggiungi-simulazione" element={<AddSimulazioni />} />
          <Route
            path="/esperienze-lavorative"
            element={<EsperienzeLavorative />}
          />
          <Route
            path="/esperienze-lavorative/:id"
            element={<EditEsperienzeLavorative />}
          />
          <Route
            path="/aggiungi-esperienze-lavorative"
            element={<AddEsperienzaLavorativa />}
          />
          <Route path="/utenti" element={<Users />} />
          <Route path="/utenti/:id" element={<EditUser />} />
          <Route path="/aggiungi-utente" element={<AddUser />} />
          <Route
            path="/profilo"
            element={
              userRole === "TRAINER" ? (
                <TrainerProfile />
              ) : userRole === "ADMIN" || userRole === "OPERATOR" ? (
                <UserProfile />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route path="/accordo-quadro" element={<AccordoQuadro />} />
          <Route
            path="/aggiungi-accordo-quadro"
            element={<AddAccordoQuadro />}
          />
          <Route path="/accordo-quadro/:id" element={<EditAccordoQuadro />} />
          <Route path="/interviste" element={<Interviste />} />
          <Route path="/aggiungi-intervista" element={<AddIntervista />} />
          <Route path="/intervista/:id" element={<EditIntervista />} />
        </Routes>
        <ToastContainer />
      </div>
    </div>
  );
}

export default App;
